import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';

const isPrivilegedUser = _.get(window, 'isPrivilegedUser', false);

const configuration = {
  type: 'relativeStrengthIndex',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'relativeStrengthIndex',
    name: 'rsi',
    config: {
      noOfCandles: 14,
      candleInterval: '5 minutes',
      valuePaths: [
        'item0.equity'
      ]
    }
  },
  searchTerms: [
    'RSI (Relative Strength Index)'
  ],
  inputSchema: [
    {
      name: 'noOfCandles',
      type: pipeInputSchemaTypes.number,
      label: 'Period',
    }
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future],
    isDayCandleEnabled: isPrivilegedUser
  },
  buildOutputSchema: (pipe) => {
    const { name, type } = pipe;

    return [
      {
        name,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      }
    ];
  },
  isEnabled: true,
  priority: 4
};
export default configuration;
